<script>
import AssetDashboardCard from "@/Widgets/Cards/AssetDashboardCard.vue";

export default {
  name: "AssetsUpToDateVsRequired",
  components: {AssetDashboardCard},
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
  },
  data() {
    return {
      chartData: [],
      chartOptions: [],
    }
  },
  methods: {
    setChartData() {
      const documentStyle = getComputedStyle(document.documentElement);
      return {
        labels: [
          this.$t('widgets.charts.assets_up_to_date_vs_required.up_to_date'),
          this.$t('widgets.charts.assets_up_to_date_vs_required.update_required'),
        ],
        datasets: [
          {
            label: this.$t('common.assets'),
            data: this.data,
            hoverOffset: 4,
            borderWidth: 0,
          },
        ]
      };
    },
    setChartOptions() {
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue('--text-color');
      const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
      const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

      return {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            align: 'start',
          },

          labels: {
            render: function (args) {
              return args.value?.toLocaleString();
            },
            fontStyle: 'bold',
          },
        }
      };
    }
  },
  watch: {
    data: {
      handler: function (newValue, oldValue) {
        this.chartData = this.setChartData();
      },
      immediate: true
    }
  },
  mounted() {
    this.chartOptions = this.setChartOptions();
  }
}
</script>

<template>
  <AssetDashboardCard
      :title="$t('widgets.charts.assets_up_to_date_vs_required.up_to_date_assets')"
      :subtitle="$t('widgets.charts.assets_up_to_date_vs_required.vs_update_required')"
      :loading="loading"
  >
    <Chart type="doughnut" :data="chartData" :options="chartOptions"/>
  </AssetDashboardCard>
</template>

<style scoped>

</style>